import styled from '@emotion/styled';
import { Button, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { colors } from '~/theme';
import LogoutIcon from '@mui/icons-material/Logout';
import config from '~/config';

const Logo = styled('img')(() => ({ height: 64, width: 64 }));

function getImageSrc() {
  const host = window.location.host.toLowerCase();
  const cubHost = config.CUB_HOST.toLowerCase();
  const isCubHost = host === cubHost;

  const label = host.split('.')[0].replace(/-cliente$/g, '');
  const assetsBaseUrl = config.WHITELABEL_ASSETS_BASE_URL + '/' + label;

  return isCubHost ? '/cub.png' : assetsBaseUrl + '/header-logo.png';
}

export const Header: FC<Props> = ({ logout, showExitIdentityCheckFlowButton }) => {
  return (
    <Box sx={{ background: colors.white }}>
      <Box
        sx={{
          maxWidth: '1200px',
          margin: 'auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack direction="row" alignItems="center" paddingY={3} marginX={{ xs: 3, md: 3 }}>
          <Logo alt="Logo" src={getImageSrc()} />
        </Stack>
        <Box>
          {showExitIdentityCheckFlowButton && (
            <Button
              onClick={() => (window.location.href = '/')}
              color="primary"
              endIcon={<LogoutIcon />}
              sx={{ fontWeight: 'bold', mr: 5 }}
            >
              cancelar validação
            </Button>
          )}
          {logout && (
            <Button onClick={logout} color="primary" endIcon={<LogoutIcon />} sx={{ fontWeight: 'bold' }}>
              sair
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

interface Props {
  logout?: () => void;
  showExitIdentityCheckFlowButton?: boolean;
}
